import {
  dimensionsRatio,
  setupDocumentDimensions,
} from 'affiny-core/helpers/dimensions';
import { isWeb } from 'affiny-core/helpers/targetCheck/targetCheck';
import rem from '../utils/rem';
import { IFontSizes } from './IFontSizes';

setupDocumentDimensions();

/* Because ReactNative don't support rem */
const isOnWeb = isWeb();

const integerFontSize = {
  size8Int: 8 * dimensionsRatio.width,
  size12Int: 12 * dimensionsRatio.width,
  size14Int: 14 * dimensionsRatio.width,
  size16Int: 16 * dimensionsRatio.width,
  size18Int: 18 * dimensionsRatio.width,
  size20Int: 20 * dimensionsRatio.width,
  size24Int: 24 * dimensionsRatio.width,
  size30Int: 30 * dimensionsRatio.width,
  size32Int: 32 * dimensionsRatio.width,
  size36Int: 36 * dimensionsRatio.width,
  size48Int: 48 * dimensionsRatio.width,
};

export const fontSizes: IFontSizes = {
  ...integerFontSize,
  size8: isOnWeb
    ? rem(integerFontSize.size8Int)
    : `${integerFontSize.size8Int}px`,
  size12: isOnWeb
    ? rem(integerFontSize.size12Int)
    : `${integerFontSize.size12Int}px`,
  size14: isOnWeb
    ? rem(integerFontSize.size14Int)
    : `${integerFontSize.size14Int}px`,
  size16: isOnWeb
    ? rem(integerFontSize.size16Int)
    : `${integerFontSize.size16Int}px`,
  size18: isOnWeb
    ? rem(integerFontSize.size18Int)
    : `${integerFontSize.size18Int}px`,
  size20: isOnWeb
    ? rem(integerFontSize.size20Int)
    : `${integerFontSize.size20Int}px`,
  size24: isOnWeb
    ? rem(integerFontSize.size24Int)
    : `${integerFontSize.size24Int}px`,
  size30: isOnWeb
    ? rem(integerFontSize.size30Int)
    : `${integerFontSize.size30Int}px`,
  size32: isOnWeb
    ? rem(integerFontSize.size32Int)
    : `${integerFontSize.size32Int}px`,
  size36: isOnWeb
    ? rem(integerFontSize.size36Int)
    : `${integerFontSize.size36Int}px`,
  size48: isOnWeb
    ? rem(integerFontSize.size48Int)
    : `${integerFontSize.size48Int}px`,
};
